<template>
  <b-container class="center_body" style="text-align: left">
    <div>
      <b-button class="btn_item1" variant="outline-secondary">2022年共享航次计划</b-button>
      <b-button class="btn_item2" variant="outline-secondary" @click="goDiaryIndex">航次日记列表</b-button>
    </div>
    <b-row class="diary_body" @click="godiaryDetail">
      <!--   列表   -->
      <b-col class="diary_list" lg="4" xl="4" sm="12" md="6" v-for="item in diaryList" :key="item.id">
        <b-card
            title=""
            img-src=""
            img-alt="Image"
            img-top
            tag="article"
            style="max-width: 100%;"
            class="mb-2"
        >
          <div class="diary_image" v-b-tooltip title="Read More">
            <b-img center  :src="item.img ? item.img : require('../../statics/noImg.png')" fluid alt="Fluid image"></b-img>
          </div>
          <b-card-text class="diary_title" v-b-tooltip title="Read More">
            {{item.title }}
          </b-card-text>
          <b-card-text class="diary_intro" v-b-tooltip title="Read More">
            {{item.introduce }}
          </b-card-text>

          <b-card-text v-b-tooltip title="Read More">
            {{item.time }}
          </b-card-text>
        </b-card>
      </b-col>
    </b-row>

    <link-component></link-component>
  </b-container>
</template>

<script>
import LinkComponent from '../../components/LinkComponent.vue';
import { axiosServer } from '@/api/judge';
import { urls } from '@/api/urls';
import {diaryLists} from '../../mock/diary'

export default {
  components: {
    LinkComponent,
  },
  // name: "about",
  props: {},
  computed: {},
  data() {
    return {
      diaryList:[

      ],
      reqBody: {
        page: 1,
        pageSize: 200,
        cruiseId: '',
        cruiseName: '',
        cruiseYear: null
      },
      years: [
        {
          value: null,
          text: '全部年份'
        },
        {
          value: '2022',
          text: '2022'
        },
        {
          value: '2021',
          text: '2021'
        },
        {
          value: '2020',
          text: '2020'
        },
        {
          value: '2019',
          text: '2019'
        },
        {
          value: '2018',
          text: '2018'
        },
        {
          value: '2017',
          text: '2017'
        },
        {
          value: '2016',
          text: '2016'
        },
        {
          value: '2015',
          text: '2015'
        },
        {
          value: '2014',
          text: '2014'
        },
        {
          value: '2013',
          text: '2013'
        },
        {
          value: '2012',
          text: '2012'
        },
        {
          value: '2011',
          text: '2011'
        },
        {
          value: '2010',
          text: '2010'
        }
      ],
    };
  },
  //       computed: {
  // },
  mounted() {
    this.getList();
  },
  methods: {
    getList(){
      const diary = diaryLists()
      this.diaryList = diary;
      console.log('666', this.diaryList)
    },
    // 返回列表页
    goDiaryIndex(){
      this.$router.push({ name: 'diary' });
    },
    //  进入日记
    godiaryDetail(){
      console.log('跳转')
      this.$router.push({ name: 'diary_detail' ,params: { data: '我是要传递的参数' }});
    }
  },
};
</script>

<style lang="less" scoped>
.center_body{
  margin-top: 20px;

  .btn_item1{
    border-color: #dfdfdf;
  }
  .btn_item2{
    margin-left: 10px;
    border-color: #dfdfdf;
  }

  .diary_body{
    margin-top: 20px;
    .diary_list{
      margin-bottom: 10px;
      .card-body{
        padding-top: 0.5rem;
        padding-bottom: 1rem;
        .diary_image{
          background-color: rgb(245, 245, 245);
          min-height: 154px;
          overflow: hidden;
        }
        .diary_title{
          font-size: 1.3rem;
          margin: 0.75rem 0 0.75rem 0;
          font-weight: 600;
          line-height: 1.2;
        }
        .diary_intro{
          width: 100%;

          height: 100px;

          overflow: hidden;

          text-overflow: ellipsis;

          display: -webkit-box;

          -webkit-line-clamp: 4;

          -webkit-box-orient: vertical;
        }
      }
    }
  }
}


</style>
